/**
 * Simulacao Pix Dinamico
 * Gera QR Code mock e simula webhook de confirmacao
 */

export function generatePixPayload(orderId, amount, businessName = 'Kaven Local') {
  const txid = `KAVEN${orderId}${Date.now().toString(36).toUpperCase()}`;
  const payload = {
    txid,
    chave: 'pix@kavenlocal.com.br',
    valor: amount.toFixed(2),
    nome: businessName,
    cidade: 'Mage',
    descricao: `Pedido #${orderId}`,
    qrCodeText: `00020126580014BR.GOV.BCB.PIX0136${txid}5204000053039865406${amount.toFixed(2)}5802BR5913${businessName}6004Mage62070503***6304`,
  };
  return payload;
}

// SVG-based simple QR code visual (mock - not a real scannable QR)
export function generateQRCodeSVG(text, size = 200) {
  const modules = 21;
  const cellSize = size / modules;
  let rects = '';

  // Simple deterministic pattern based on text hash
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = ((hash << 5) - hash + text.charCodeAt(i)) | 0;
  }

  const seededRandom = (seed) => {
    seed = (seed * 16807) % 2147483647;
    return (seed - 1) / 2147483646;
  };

  let seed = Math.abs(hash);

  // Position detection patterns (corners)
  const drawFinderPattern = (x, y) => {
    for (let r = 0; r < 7; r++) {
      for (let c = 0; c < 7; c++) {
        const isOuter = r === 0 || r === 6 || c === 0 || c === 6;
        const isInner = r >= 2 && r <= 4 && c >= 2 && c <= 4;
        if (isOuter || isInner) {
          rects += `<rect x="${(x + c) * cellSize}" y="${(y + r) * cellSize}" width="${cellSize}" height="${cellSize}" fill="#0A0A0A"/>`;
        }
      }
    }
  };

  drawFinderPattern(0, 0);
  drawFinderPattern(modules - 7, 0);
  drawFinderPattern(0, modules - 7);

  // Data modules
  for (let r = 0; r < modules; r++) {
    for (let c = 0; c < modules; c++) {
      const inFinder =
        (r < 8 && c < 8) || (r < 8 && c >= modules - 8) || (r >= modules - 8 && c < 8);
      if (inFinder) continue;

      seed = (seed * 16807) % 2147483647;
      if (seededRandom(seed) > 0.55) {
        rects += `<rect x="${c * cellSize}" y="${r * cellSize}" width="${cellSize}" height="${cellSize}" fill="#0A0A0A"/>`;
      }
    }
  }

  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}"><rect width="${size}" height="${size}" fill="white"/>${rects}</svg>`;
}

// Simulate payment webhook with delay
export function simulatePixPayment(onConfirm, delayMs = 4000) {
  const timer = setTimeout(() => {
    onConfirm({ status: 'confirmed', paidAt: new Date().toISOString() });
  }, delayMs);
  return () => clearTimeout(timer);
}
